export const META_CONTENT = {
  SITE_NAME: 'HireFy',
  BASE_URL: 'https://www.hirefy.co.uk',
  DEFAULT_OG_IMAGE: 'https://www.hirefy.co.uk/og-image.jpg',
  TWITTER_HANDLE: '@hirefy',

  DESCRIPTIONS: {
    TOOL_HIRE: (city: string) => 
      `Find quality tool hire in ${city}. Compare local equipment hire providers, read reviews, and get competitive prices.`,
    SKIP_HIRE: (city: string) => 
      `Book reliable skip hire services in ${city}. Compare skip sizes and prices from trusted local providers.`,
    SCAFFOLD_TOWER: (city: string) => 
      `Hire scaffold towers in ${city}. Safe and certified equipment from approved local providers.`,
    DIGGER_HIRE: (city: string) => 
      `Find digger and mini excavator hire in ${city}. Compare prices and availability from local plant hire companies.`,
    GARDEN_TOOL: (city: string) => 
      `Hire garden tools and equipment in ${city}. Professional landscaping equipment from local providers.`
  },

  TITLES: {
    TOOL_HIRE: (city: string) => 
      `Tool Hire in ${city} | Local Equipment Hire`,
    SKIP_HIRE: (city: string) => 
      `Skip Hire in ${city} | Local Skip Rental`,
    SCAFFOLD_TOWER: (city: string) => 
      `Scaffold Tower Hire in ${city} | Safe Access Solutions`,
    DIGGER_HIRE: (city: string) => 
      `Digger Hire in ${city} | Local Plant Hire`,
    GARDEN_TOOL: (city: string) => 
      `Garden Tool Hire in ${city} | Landscaping Equipment`,
    
    HOME: 'HireFy | Find Quality Equipment Hire Near You',
    ABOUT: 'About HireFy | Your Equipment Hire Directory',
    CONTACT: 'Contact Us | HireFy Equipment Hire',
    CATEGORIES: 'Equipment Categories | Find Local Hire Services',
    PRIVACY: 'Privacy Policy | HireFy',
    TERMS: 'Terms of Use | HireFy'
  }
};